"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.date.now");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.assign");

var _regeneratorRuntime = require("@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitContactForm = submitContactForm;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _axios = _interopRequireDefault(require("axios"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Util = require("../Util");

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function submitContactForm(_x, _x2, _x3) {
  return _submitContactForm.apply(this, arguments);
}

function _submitContactForm() {
  _submitContactForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref, fields, context) {
    var formId, portalId, url;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            formId = _ref.formId, portalId = _ref.portalId;
            url = "https://api.hsforms.com/submissions/v3/integration/submit/".concat(portalId, "/").concat(formId);
            return _context2.abrupt("return", _axios["default"].post(url, {
              submittedAt: Date.now(),
              fields: Object.keys(fields).map(function (x) {
                return {
                  name: x.replace(/\s+/, '').toLowerCase(),
                  value: fields[x]
                };
              }),
              context: context,
              skipValidation: false
            }).then(function (res) {
              return res.data.inlineMessage;
            })["catch"](function (res) {
              return res.data ? res.data.message : 'Form Submit Failed';
            }));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _submitContactForm.apply(this, arguments);
}

var ContactForm = /*#__PURE__*/function (_react$default$Compon) {
  _inheritsLoose(ContactForm, _react$default$Compon);

  var _super = _createSuper(ContactForm);

  function ContactForm(props) {
    var _this2;

    var _this;

    _this2 = _react$default$Compon.call(this, props) || this;
    _this = _assertThisInitialized(_this2);

    _defineProperty(_assertThisInitialized(_this2), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var message;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                _this2.setState({
                  loading: true
                });

                _context.prev = 2;
                _context.next = 5;
                return submitContactForm({
                  formId: _this2.props.formId,
                  portalId: _this2.props.portalId
                }, _this2.fields.reduce(function (obj, x) {
                  obj[x] = _this2.state[x];
                  return obj;
                }, {}), {
                  pageUri: window.location.href,
                  pageName: window.location.title
                });

              case 5:
                message = _context.sent;

                _this2.setState({
                  loading: false,
                  successMessage: message || _this2.props.successMessage
                });

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);

                _this2.setState({
                  loading: false,
                  errorMessage: _context.t0 ? _context.t0.message : 'Form submit failed'
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }));

      return function (_x4) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this2), "getInputHandler", function (name) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return function (e) {
        var _Object$assign;

        _this.setState(Object.assign(state, (_Object$assign = {}, _Object$assign[name] = e.target.value, _Object$assign)));
      };
    });

    if (typeof props.fields === 'string') {
      _this2.fields = props.fields.split(',').map(function (x) {
        return x.trim();
      });
    } else {
      _this2.fields = props.fields;
    }

    _this2.state = {
      loading: false,
      errorMessage: '',
      successMessage: ''
    };

    _this2.fields.forEach(function (x) {
      _this2.state[x] = '';
    });

    return _this2;
  }

  var _proto = ContactForm.prototype;

  _proto.deriveProps = function deriveProps() {
    var newProps = (0, _Util.mergeProps)(this.props, ContactForm);

    if (typeof newProps.title === 'undefined') {
      newProps.title = 'Signup for our news letter';
    }

    if (!newProps.button) {
      newProps.button = 'Subscribe';
    }

    return newProps;
  };

  _proto.render = function render() {
    var _this3 = this; // eslint-disable-next-line object-curly-newline


    var _this$deriveProps = this.deriveProps(),
        className = _this$deriveProps.className,
        style = _this$deriveProps.style,
        title = _this$deriveProps.title,
        button = _this$deriveProps.button,
        layout = _this$deriveProps.layout;

    var _this$state = this.state,
        loading = _this$state.loading,
        errorMessage = _this$state.errorMessage,
        successMessage = _this$state.successMessage;
    return _react["default"].createElement(Form, {
      onSubmit: this.onSubmit,
      className: className,
      style: style,
      layout: layout,
      fieldCount: this.fields.length,
      name: "subscribe"
    }, !!title && _react["default"].createElement(_Typography["default"], {
      component: "p",
      className: "title"
    }, title), _react["default"].createElement("div", {
      className: "form-controls"
    }, this.fields.map(function (x) {
      return _react["default"].createElement("input", {
        required: true,
        key: x,
        type: "text",
        value: _this3.state[x],
        onChange: _this3.getInputHandler(x),
        className: "input",
        placeholder: x
      });
    }), _react["default"].createElement(_Button["default"], {
      variant: "outlined",
      type: "submit",
      color: "default",
      size: "large",
      disabled: loading,
      className: "subscribe-btn-empty"
    }, loading ? _react["default"].createElement(_CircularProgress["default"], {
      size: 28
    }) : button)), !!errorMessage && _react["default"].createElement(_Typography["default"], {
      component: "p",
      variant: "body1",
      className: "error",
      color: "secondary",
      dangerouslySetInnerHTML: {
        __html: errorMessage
      }
    }), !!successMessage && _react["default"].createElement(_Typography["default"], {
      component: "p",
      variant: "body1",
      className: "success",
      color: "primary",
      dangerouslySetInnerHTML: {
        __html: successMessage
      }
    }));
  };

  return ContactForm;
}(_react["default"].Component); // prettier-ignore


exports["default"] = ContactForm;

_defineProperty(ContactForm, "propTypes", {
  style: _propTypes["default"].object,
  className: _propTypes["default"].string,
  portalId: _propTypes["default"].string,
  formId: _propTypes["default"].string,
  title: _propTypes["default"].string,
  button: _propTypes["default"].string,
  successMessage: _propTypes["default"].string,
  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  fields: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array])
});

_defineProperty(ContactForm, "defaultProps", {
  style: {},
  className: '',
  portalId: '4796488',
  formId: '929a510f-34f4-4251-98b3-34175200aebd',
  title: undefined,
  button: '',
  layout: 'vertical',
  successMessage: 'Form Submit Success',
  fields: ['Email', 'First Name', 'Last Name']
});

var getInputWidth = function getInputWidth(props) {
  return props.layout === 'vertical' ? '100%' : "".concat(Math.max(95 / (props.fieldCount + 1), 20), "%");
};

var Form = _styledComponents["default"].form.withConfig({
  displayName: "ContactForm__Form",
  componentId: "sc-1ps0j3m-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;@media (max-width:", "px){width:100% !important;}max-width:800px;margin:0px auto;.title{font-size:30px;text-align:center;color:", ";}.form-controls{width:100%;flex-direction:", ";justify-content:space-between;align-items:center;.input{width:", ";height:50px;border:none;border-bottom:1px solid ", ";font-size:16px;letter-spacing:1.8px;outline:none;margin:", ";background:transparent;&:first-of-type{margin-top:40px;}}.subscribe-btn-empty{margin-top:", ";width:", ";}}.error,.success{margin-top:20px;}"], function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return props.theme.typography.color.main;
}, function (props) {
  return props.layout === 'vertical' ? 'column' : 'row';
}, function (props) {
  return getInputWidth(props);
}, function (props) {
  return props.theme.typography.color.main;
}, function (props) {
  return props.layout === 'vertical' ? '12px 0' : '12px';
}, function (props) {
  return props.layout === 'vertical' ? '40px' : '0';
}, function (props) {
  return props.layout === 'vertical' ? '100%' : 'auto';
});